import { render, staticRenderFns } from "./ProcessingErrorsChart.vue?vue&type=template&id=78958850&"
import script from "./ProcessingErrorsChart.vue?vue&type=script&lang=js&"
export * from "./ProcessingErrorsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports